export enum DeadStockEnum{
    BELOW_100_DAYS = 'Below 100 days',
    BELOW_180_DAYS = 'Below 180 days',
    ABOVE_180_DAYS = 'Above 180 days',
}